import React, { PureComponent } from 'react'
import moment from 'moment'
import { array } from 'helpers'
import cx from 'classnames'

import MonthView from './MonthView/MonthView'

import s from './Calendar2.scss'


class Calendar2 extends PureComponent {

  constructor(props) {
    super()

    this.state = {
      selectedDates: props.day ? [ moment(props.day, 'DD') ] : props.selectedDates || [ moment().startOf('day') ],
      year: props.year || moment().format('YYYY'),
      month: props.month || moment().format('MM'),
      view: 'month',
      selectedWeekDay: null,
      isAltPressed: false,
      isShiftPressed: false,
    }
  }
  
  componentDidMount() {
    this.addListeners()
  }

  componentWillUnmount() {
    this.removeListeners()
  }

  addListeners = () => {
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
  }

  removeListeners = () => {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('keyup', this.handleKeyUp)
  }

  handleKeyUp = (event) => {
    if (event.key === 'Shift' || event.key === 'Alt') {
      this.setState({
        isAltPressed: false,
        isShiftPressed: false,
      })
    }
  }

  handleKeyDown = (event) => {
    if (event.key === 'Shift' || event.key === 'Alt') {
      this.setState({
        isAltPressed: event.key === 'Alt',
        isShiftPressed: event.key === 'Shift',
      })
    }
  }

  goMonth = (to) => {
    const { year, month } = this.state

    const newMonth = moment(`${month}.${year}`, 'MM.YYYY').add({ month: to })

    this.setState({
      year: newMonth.format('YYYY'),
      month: newMonth.format('MM'),
    })
  }

  onDayClick = (day) => {
    const { month, year, selectedDates, isAltPressed, isShiftPressed } = this.state
    const { isRange = true, onChange } = this.props

    let _selectedDates

    if (isRange && isAltPressed) {
      const newDay        = moment(`${day}.${month}.${year}`, 'DD.MM.YYYY')
      const isDateExists  = selectedDates.some((day) => (
        day.format('DD.MM.YYYY') === newDay.format('DD.MM.YYYY')
      ))

      _selectedDates = (
        isDateExists
          ? selectedDates.filter((day) => (
            day.format('DD.MM.YYYY') !== newDay.format('DD.MM.YYYY')
          ))
          : selectedDates.concat(newDay)
      )
    }
    else if (isRange && isShiftPressed) {
      // TODO select activeDates from selectedDates array
      const activeDate    = selectedDates[0]
      const newDay        = moment(`${day}.${month}.${year}`, 'DD.MM.YYYY')
      const from          = activeDate > newDay ? newDay : activeDate
      const to            = activeDate > newDay ? activeDate : newDay
      const days          = (to - from) / 1000 / 60 / 60 /24 + 1

      _selectedDates = array.range(1, days).map((day) => moment(from).add({ days: day - 1 }))
    }
    else {
      _selectedDates = [ moment(`${day}.${month}.${year}`, 'DD.MM.YYYY') ]
    }

    this.setState({
      selectedWeekDay: null,
      selectedDates: _selectedDates,
    })

    onChange(_selectedDates)
  }

  onWeekDayClick = (weekDay) => {
    const { month, year } = this.state
    const { isRange = true, onChange } = this.props

    if (isRange) {
      const selectedDates = this.getVisibleDays()
        .map((day) => moment(`${day}.${month}.${year}`, 'DD.MM.YYYY'))
        .filter((day) => day.weekday() === weekDay)

      this.setState({
        selectedWeekDay: weekDay,
        selectedDates,
      })

      onChange(selectedDates)
    }
  }

  getVisibleDays = () => {
    const { month, year } = this.state

    const endOfMonth = moment(`${month}.${year}`, 'MM.YYYY').endOf('month')

    return array.range(1, Number(endOfMonth.format('DD')))
  }

  render() {
    const { view, year, month, selectedDates } = this.state
    const { className, backgrounds = {}, isFutureOnly = true, gutter = 'xlg', onClick } = this.props

    const days                = this.getVisibleDays()
    const isPrevArrowVisible  = !isFutureOnly || (
      Number(month) > Number(moment().format('MM'))
      || Number(year) > Number(moment().format('YYYY'))
    )

    return (
      <div className={cx(s.calendar, className)} onClick={onClick}>
        {
          view === 'month' && (
            <MonthView
              days={days}
              year={year}
              month={month}
              gutter={gutter}
              backgrounds={backgrounds}
              selectedDates={selectedDates}
              isPrevArrowVisible={isPrevArrowVisible}
              goNextMonth={() => this.goMonth(1)}
              goPrevMonth={() => this.goMonth(-1)}
              onDayClick={this.onDayClick}
              onWeekDayClick={this.onWeekDayClick}
            />
          )
        }
      </div>
    )
  }
}


export default Calendar2